import * as path from 'node:path';
import type { WorktreeLayoutFile } from '../worktree-layout-file.js';
import { getLauncherDirNameIfPresent } from '../worktree-layout-file.js';

/**
 * Layout keys plausibly tied to this bridge root (exact match, bridge nested under entry, or entry nested under bridge).
 * When any match exists, unrelated keys under worktreesRoot are skipped so legacy scans do not walk other projects.
 */
export function layoutKeysForBridgeRoot(
  layout: WorktreeLayoutFile,
  bridgeRoot: string,
  keysOnDisk: string[],
): string[] {
  const bridge = path.resolve(bridgeRoot);
  const preferred = getLauncherDirNameIfPresent(layout, bridgeRoot);

  const relevant = layout.launcherCwds
    .filter((e) => {
      const entry = path.resolve(e.absolutePath);
      return (
        bridge === entry ||
        bridge.startsWith(entry + path.sep) ||
        entry.startsWith(bridge + path.sep)
      );
    })
    .sort((a, b) => path.resolve(b.absolutePath).length - path.resolve(a.absolutePath).length)
    .map((e) => e.dirName)
    .filter((name) => keysOnDisk.includes(name));

  const ordered: string[] = [];
  const seen = new Set<string>();
  const add = (k: string) => {
    if (seen.has(k) || !keysOnDisk.includes(k)) return;
    seen.add(k);
    ordered.push(k);
  };

  if (preferred) add(preferred);
  for (const k of relevant) add(k);

  if (relevant.length > 0) {
    return ordered;
  }

  for (const k of keysOnDisk) add(k);
  return ordered;
}
